/** Cifre di una partita IVA italiana (`REGEX.VAT`). */
export const ITALIAN_VAT_LENGTH = 11;
/**
 * P.IVA come la scrive l'utente per il lookup VIES (prefisso paese, spazi,
 * punti e trattini ammessi): lunghezze accettate prima della normalizzazione.
 */
export const VAT_LOOKUP_INPUT_MIN_LENGTH = 4;
export const VAT_LOOKUP_INPUT_MAX_LENGTH = 20;
export const VAT_LOOKUP_INPUT_REGEX = new RegExp(`^[0-9A-Za-z+*. -]{${VAT_LOOKUP_INPUT_MIN_LENGTH},${VAT_LOOKUP_INPUT_MAX_LENGTH}}$`);
export const REGEX = {
    IBAN: /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/i,
    FISCAL_CODE: /^[A-Z]{6}[\dLMNP-V]{2}[A-EHLMPR-T][\dLMNP-V]{2}[A-Z][\dLMNP-V]{3}[A-Z]$/i,
    FISCAL_CODE_OR_VAT: /^(\d{11}|[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$/i,
    VAT: new RegExp(`^\\d{${ITALIAN_VAT_LENGTH}}$`),
    FOREIGN_VAT_ID: /^(?:\d{11}|IT\d{11}|(?!IT)[A-Z]{2}[A-Z0-9]{2,28})$/,
    BIC: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/i,
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/i,
    ALPHANUMERIC_CHARACTERS: /^[a-zA-Z0-9]+$/,
    NUMBERS_ONLY: /^[0-9]+$/,
    NUMBERS_WITH_KEYBOARD_KEYS: /(^-?\d*[.,]?\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/,
    INVALID_LETTERS_REGEX: /[a-df-zA-DF-Z]/,
    WEBSITE: /^www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
};
//# sourceMappingURL=regex.js.map